// Le déblocage des pièces d'avatar : ce qui se calcule à partir d'une pièce (lib/avatar/pieces.js)
// et de sa condition, côté serveur comme dans l'éditeur. Une pièce débloquée l'est pour toujours
// (table user_avatar_items côté back).

import { CUSTOM_CATEGORIES } from "./pieces.js";
import { AVATAR_CATEGORIES } from "./catalog.js";

const staticOptions = (key) => AVATAR_CATEGORIES.find((category) => category.key === key).options;

// Retire d'un avatar ce que le membre n'a pas le droit de porter : une pièce qui n'existe
// pas (ni dans le catalogue ni parmi `pieces`), ou une pièce à débloquer qu'il n'a pas
// (`owned` : liste des « catégorie:identifiant » débloqués). La catégorie repasse à « none »,
// ou, quand elle n'a pas de « none » (coiffure, tenue), à la pièce de `fallback`.
export function withoutLockedPieces(avatar, owned, pieces, fallback = {}) {
    const result = { ...avatar };
    for (const key of CUSTOM_CATEGORIES) {
        const value = result[key];
        if (staticOptions(key).includes(value)) continue;
        const piece = pieces?.[`${key}:${value}`];
        if (!piece || (piece.condition && !owned.includes(piece.item))) {
            result[key] = staticOptions(key).includes("none") ? "none" : fallback[key] ?? staticOptions(key)[0];
        }
    }
    return result;
}

// Où en est une période par rapport à maintenant : "upcoming", "open" ou "closed".
// Les bornes sont à l'heure de Paris ; `now` est une date « AAAA-MM-JJ HH:mm:ss » de Paris.
export function periodState(period, now) {
    if (now < period.from) return "upcoming";
    return now > period.to ? "closed" : "open";
}

// La période à montrer au membre : celle en cours, sinon la prochaine, sinon la dernière passée.
export function currentPeriod(periods, now) {
    if (!periods?.length) return null;
    return (
        periods.find((period) => periodState(period, now) === "open") ||
        periods.find((period) => periodState(period, now) === "upcoming") ||
        periods[periods.length - 1]
    );
}

// Faut-il montrer cette pièce verrouillée dans l'éditeur ? `entry` : sa ligne dans la liste
// `locked` de /api/avatar/items, absente tant que la réponse n'est pas arrivée.
export function showsWhenLocked(piece, entry) {
    const visibility = piece.visibility || "always";
    if (visibility === "always") return true;
    return visibility === "event" && entry?.state === "open";
}
